export default "__VITE_ASSET__CRmenIKZ__"